import {
  Autocomplete,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import React from 'react';
import { vehicalInspectionList } from '../Data/GenTaskInputfieldsData';

const autoCompleteSlotProps = {
  paper: {
    sx: {
      '& .MuiAutocomplete-option': {
        fontSize: '0.82rem',
        fontWeight: 500,
      },
    },
  },
};

const VehicalChecklistTable = ({ checklistData, checkListOptions, handleCheckListDataEdit }) => {
  // Guard: don't render until checklistData is a valid object
  if (!checklistData || typeof checklistData !== 'object') {
    return (
      <Grid item xs={12}>
        <Typography variant="caption" color="text.secondary">
          Loading checklist...
        </Typography>
      </Grid>
    );
  }

  return (
    <Grid item xs={6} sm={6} md={12}>
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: '10px',
          overflow: 'hidden',
          boxShadow: 1,
        }}>
        <Table border={1} size="small" sx={{ border: '1px solid #ccc', fontSize: '0.825rem' }}>
          <TableHead>
            <TableRow>
              <TableCell width="70%"></TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {vehicalInspectionList.map((item, index) => (
              <TableRow key={`${index}_${item.label}`}>
                <TableCell>{item.label}</TableCell>
                <TableCell>
                  <Autocomplete
                    size="small"
                    disablePortal
                    name={item.key}
                    // Safe access — falls back to null if key missing
                    value={checklistData[item.key] ?? null}
                    options={['Faulty', 'Repaired']}
                    onChange={(_, newValue) => handleCheckListDataEdit(item.key, newValue)}
                    sx={{ fontSize: '0.8rem' }}
                    renderInput={params => <TextField {...params} size="small" fullWidth />}
                    fullWidth
                    slotProps={{ ...autoCompleteSlotProps }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default VehicalChecklistTable;
